module.exports = __webpack_public_path__ + "static/media/check_icon.b8a356d0.svg";